import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import Footer from "../Footer/Footer";
import Nav from "../Nav/Nav";
import useStore from "../../../Store";
import Services1 from "./Services1";
import { useParams } from "react-router-dom";
import styles from "./Readmore.module.css";
import { useForm } from "react-hook-form";
import {
    getServicesById,
    ServiceReplycreateServiceReply,
} from "../../../Services/APIrequests";
import parse from "html-react-parser";
import dummyImg from "../../../Assets/dummy.png";
import { FaRupeeSign } from "react-icons/fa";
import { SuccessSwal, warningSwal } from "../../../Util/Toast";
import numberToWords from "number-to-words";

const Readmore = () => {
    const { servicesid } = useParams();
    const [services, setServices] = useState(null);
    const [loading, setLoading] = useState(true);
    const direction = useStore((state) => state.direction);
    const [selectedTitleIndex, setSelectedTitleIndex] = useState(0);
    const [showAllDocs, setShowAllDocs] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const handleTitleClick = (index) => {
        setSelectedTitleIndex(index);
    };

    useEffect(() => {
        const fetchResource = async () => {
            try {
                console.log("Fetching service details with ID:", servicesid);
                const response = await getServicesById(servicesid);
                console.log("Service details fetched:", response.data);
                setServices(response.data);
            } catch (error) {
                console.error("Error fetching resource:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchResource();
    }, [servicesid]);

    const onSubmit = async (data) => {
        const requestBody = {
            serviceId: servicesid,
            name: data.fullname,
            email: data.emailaddress,
            subject: data.subject,
            message: data.message,
        };

        try {
            console.log("Submitting service reply:", requestBody);
            const response = await ServiceReplycreateServiceReply(requestBody);
            console.log("Service reply submitted:", response.data);
            SuccessSwal("Your reply has been submitted successfully!");
            reset();
        } catch (error) {
            console.error("Error submitting service reply:", error);
            warningSwal("Something went wrong. Please try again later.");
        }
    };

    if (loading) {
        console.log("Loading service details...");
        return (
            <div style={{ direction }}>
                <Nav />
                <Services1 />
                <div className={styles.Single_container}>
                    <p className={styles.errorMsg}>
                        Loading service details...
                    </p>
                </div>
                <Footer />
            </div>
        );
    }

    if (!services || !services.service) {
        console.log("Service not found:", servicesid);
        return (
            <div style={{ direction }}>
                <Nav />
                <Services1 />
                <div className={styles.Single_container}>
                    <div className={styles.Single_container_content}>
                        <div className={styles.Single_content_img}>
                            <p className={styles.errorMsg}>
                                Service details not found.
                            </p>
                        </div>
                        <div className={styles.Single_content_data}>
                            <p className={styles.errorMsg}>
                                Sorry, we couldn't find the details for this
                                service.
                            </p>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    const requiredDocs = services.service.requiredDocumentsList || [];
    const visibleDocs = showAllDocs ? requiredDocs : requiredDocs.slice(0, 3);

    return (
        <div style={{ direction }}>
            <Nav />
            {/* <Services1 /> */}
            <Services1 serviceUrl={services?.service?.serviceUrl} />

            <div className={styles.Single_container}>
                <div className={styles.Single_container_content}>
                    <h1 className={styles.Single_container_mainheading}>
                        {services.service.title}
                    </h1>

                    <div className={styles.Single_box_content}>
                        <div className={styles.Single_content_Top}>
                            <div className={styles.Single_content_img}>
                                {services.service.videoUrl &&
                                services.service.videoUrl !== "NA" ? (
                                    <div className={styles.ReadmoreheaderVideo}>
                                        <ReactPlayer
                                            url={services.service.videoUrl}
                                            controls
                                            width="100%"
                                            height="100%"
                                        />
                                    </div>
                                ) : services.service.imageUrl ? (
                                    <div className={styles.ReadmoreheaderImage}>
                                        <img
                                            src={services.service.imageUrl}
                                            alt={services.service.title}
                                            className={styles.ReadmoreImage}
                                        />
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className={styles.Readmoreheader}>
                                {/* <p>
                  {services.service.shortDescription ||
                    "No description available"}
                </p> */}
                                <p>
                                    {services.service.shortDescription
                                        ? parse(
                                              services.service.shortDescription
                                          )
                                        : "No description available"}
                                </p>
                            </div>
                        </div>

                        <div>
                            {services.service.isPriceShown === 1 && (
                                <h4 className={styles.readmore_price}>
                                    <div>
                                        <FaRupeeSign
                                            className={styles.readmore_price}
                                        />
                                    </div>
                                    {/* <div>
                    Price: {services.service.servicePrice || "Not available"}(
                    {numberToWords.toWords(services.service.servicePrice)}{" "}
                    rupees only)
                  </div> */}
                                    <div>
                                        Price:{" "}
                                        {services.service.servicePrice ||
                                            "Not available"}{" "}
                                        (
                                        {services.service.servicePrice
                                            ? `${numberToWords
                                                  .toWords(
                                                      services.service
                                                          .servicePrice
                                                  )
                                                  .split(" ")
                                                  .map(
                                                      (word) =>
                                                          word
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                          word.slice(1)
                                                  )
                                                  .join(" ")} Rupees Only`
                                            : "Rupees Not Available"}
                                        )
                                    </div>
                                </h4>
                            )}
                        </div>
                    </div>

                    <div className={styles.readmore_heading_container}>
                        {services.service.longDescription &&
                        services.service.longDescription.length > 0 ? (
                            services.service.longDescription.map(
                                (desc, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className={styles.readmore_section}>
                                            <h2
                                                className={
                                                    styles.readmore_heading_title
                                                }>
                                                {desc.title}
                                            </h2>
                                            {desc.type === "table" &&
                                            desc.content ? (
                                                <table
                                                    className={
                                                        styles.readmore_table
                                                    }>
                                                    <thead>
                                                        <tr>
                                                            {desc.content.headers.map(
                                                                (header, i) => (
                                                                    <th key={i}>
                                                                        {header}
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {desc.content.rows.map(
                                                            (row, i) => (
                                                                <tr key={i}>
                                                                    {row.map(
                                                                        (
                                                                            cell,
                                                                            j
                                                                        ) => (
                                                                            <td
                                                                                key={
                                                                                    j
                                                                                }>
                                                                                {
                                                                                    cell
                                                                                }
                                                                            </td>
                                                                        )
                                                                    )}
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            ) : desc?.content ? (
                                                <div
                                                    className={
                                                        styles.readmore_heading_description
                                                    }
                                                    dangerouslySetInnerHTML={{
                                                        __html: desc.content,
                                                    }}
                                                />
                                            ) : (
                                                <p>No content available.</p>
                                            )}
                                        </div>
                                    );
                                }
                            )
                        ) : (
                            <p>No description available.</p>
                        )}
                    </div>

                    {requiredDocs.length > 0 && (
                        <div className={styles.requiredDocumentsSection}>
                            <h3 className={styles.requiredDocumentsTitle}>
                                Documents Required
                            </h3>
                            <ul className={styles.requiredDocumentsList}>
                                {visibleDocs.map((doc, index) => (
                                    <li
                                        key={index}
                                        className={styles.requiredDocumentItem}>
                                        <strong>
                                            {doc.requiredDocumentsList}
                                        </strong>
                                        {doc.description && (
                                            <p
                                                className={
                                                    styles.requiredDocumentDescription
                                                }>
                                                {doc.description}
                                            </p>
                                        )}
                                    </li>
                                ))}
                            </ul>
                            {requiredDocs.length > 3 && (
                                <button
                                    className={styles.loadMoreBtn}
                                    onClick={() =>
                                        setShowAllDocs(!showAllDocs)
                                    }>
                                    {showAllDocs ? "Show Less" : "Load More"}
                                </button>
                            )}
                        </div>
                    )}
                </div>

                {/* <div className={styles.commentsform}>
          <h3 className={styles.headtext}>Leave a reply</h3>
          <form onSubmit={handleSubmit(onSubmit)}>
            <img
              src={dummyImg}
              alt={services.service.title}
              className={styles.service_formimg}
            />
            <div className={styles.form1}>
              <div className={styles["form-control"]}>
                <input
                  type="text"
                  placeholder="Full Name"
                  {...register("fullname", {
                    required: "Full Name is required!",
                  })}
                />
                {errors?.fullname && (
                  <p className={styles.error}>{errors?.fullname?.message}</p>
                )}
              </div>
              <div className={styles["form-control"]}>
                <input
                  type="email"
                  placeholder="Email Address"
                  {...register("emailaddress", {
                    required: "Email Address is required!",
                  })}
                />
                {errors?.emailaddress && (
                  <p className={styles.error}>
                    {errors?.emailaddress?.message}
                  </p>
                )}
              </div>
            </div>
            <div className={styles["form-control"]}>
              <input
                type="text"
                placeholder="Subject"
                {...register("subject", {
                  required: "Subject is required!",
                })}
              />
              {errors?.subject && (
                <p className={styles.error}>{errors?.subject?.message}</p>
              )}
            </div>
            <div className={styles["form-control"]}>
              <textarea
                placeholder="Type Message"
                {...register("message", {
                  required: "Message is required!",
                })}
              />
              {errors?.message && (
                <p className={styles.error}>{errors?.message?.message}</p>
              )}
            </div>
            <div className={styles.formbtn}>
              <button className={styles.formbtnsubmit}>Submit</button>
            </div>
          </form>
        </div> */}

                <div className={styles.commentsform}>
                    {/* <h3 className={styles.headtext}>Related Images</h3> */}

                    {services.service.serviceImages?.length > 0 ? (
                        <div className={styles.imageList}>
                            {services.service.serviceImages.map(
                                (imgObj, index) => (
                                    <div className={styles.imageCard}>
                                        <div key={index}>
                                            <img
                                                src={imgObj.image}
                                                alt={imgObj.name}
                                                className={
                                                    styles.serviceImagecom
                                                }
                                            />
                                        </div>
                                        <h3 className={styles.imageName}>
                                            {imgObj.name}
                                        </h3>
                                    </div>
                                )
                            )}
                        </div>
                    ) : (
                        <p className={styles.noImages}></p>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Readmore;
